import { render, staticRenderFns } from "./add.vue?vue&type=template&id=add0d5ae"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('add0d5ae')) {
      api.createRecord('add0d5ae', component.options)
    } else {
      api.reload('add0d5ae', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=add0d5ae", function () {
      api.rerender('add0d5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/tenant/add.vue"
export default component.exports